import { Injectable } from '@angular/core';
import { NzTreeBaseService } from '../tree/nz-tree-base.service';

@Injectable()
export class NzTreeSelectService extends NzTreeBaseService {}
